export function pathToRegex(pattern: string): RegExp {
  let regexPattern = pattern.replace(/\[([^\]]+)\]/g, "([^/]+)");

  if (regexPattern.endsWith("/*")) {
    regexPattern = regexPattern.replace("/*", "(/.*)?");
  }

  return new RegExp(`^${regexPattern}$`);
}
